import { render, staticRenderFns } from "./ChatWidget.vue?vue&type=template&id=e49259c6&scoped=true"
import script from "./ChatWidget.vue?vue&type=script&lang=js"
export * from "./ChatWidget.vue?vue&type=script&lang=js"
import style0 from "./ChatWidget.vue?vue&type=style&index=0&id=e49259c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49259c6",
  null
  
)

export default component.exports